'use strict';

const _ = require('lodash');

function hashNr(key) {
    var hash = 0;
    key = key.toString();
    for (var i = 0; i < key.length; i++) {
        hash *= 16777619;
        hash ^= key.charCodeAt(i);
    }
    return (hash < 0 ? -hash : hash);
}

function pickOneCDNHost(config, options) {
    const appConfig = config || global.__config__;
    let cdnHosts = appConfig && appConfig.cdn && (appConfig.cdn.hosts || appConfig.cdn.cdnHostArr) || [];
    if (Array.isArray(cdnHosts) && cdnHosts.length > 0) {
        let idx = hashNr(Date.now() - 0) % cdnHosts.length;
        let host = cdnHosts[idx];
        if (options && options.protocol) {
            host = host.replace(/^.*\/\//, options.protocol + '://');
        }
        return host;
    }
    return '';
}

module.exports = {
    empty: function(value) {
        function _isEmpty(value) {
            if (_.isString(value)) {
                return !_.trim(value);
            } else if (_.isNumber(value)) {
                return !value;
            } else if (_.isBoolean(value)) {
                return value;
            } else if (Array.isArray(value)) {
                return value.every(_isEmpty);
            } else {
                return _.isEmpty(value);
            }
        }

        return _isEmpty(value);
    },

    removeHtmlTag: function(str) {
        return String(str).replace(/<[a-zA-Z\/][^<>]*>/g, '');
    },

    trimBoundBr: function(str) {
        if (typeof str === 'string' && str) {
            return str.replace(/\s/g, '').replace(/^(<br\/?>)+/, '').replace(/(<br\/?>)+$/, '');
        }
        return str;
    },

   resizeImage: function(url, width, height, clip, stretch) {
        let pattern = /^(.*?)(_w\d+_h\d+_c\d+_t\d+)*\.([\w]+)$/;
        let res;
        width = width || 0;
        height = height || 0;
        if (!clip && width > 0 && height > 0) {
            clip = 1;
        }
        clip = clip || 0;
        stretch = stretch || 0;
        //七牛切图
        if (url && ~url.indexOf('s.tuniu.net')) {
            url = url.replace(/_w\d+_h\d_c\d_t\d\./, '.'); // 可能被错误切图.
            if (~url.indexOf('?')) {
                url = url.split('?')[0]
            }
            let type = (clip == 0) ? 2 : 1;
            url = [url,'?imageView2/',[type,'w',width,'h',height].join('/')].join('');
           
        } else {
            if (res = pattern.exec(url)) {
                url = [
                    res[1],
                    '_', ['w' + width, 'h' + height, 'c' + clip, 't' + stretch].join('_'),
                    '.',
                    res[3]
                ].join('');
            }
        }
        if(url && url.indexOf(":")){
            return url.slice(url.indexOf(":")+1); 
        }else{
            return url;
        }
         
    },
    nb2br: function(content) {
        content = content || '';
        return content.replace(/\n+?/gm, '<br>')
    },

    calculateDuration: function(begin, end) {
        if (begin && end) {
            let pattern = /^(\d+):(\d+)$/;
            let beginRes = pattern.exec(begin);
            pattern.lastIndex = 0;
            let endRes = pattern.exec(end);

            if (beginRes && endRes) {
                return parseInt(endRes[1], 10) * 60 +
                    parseInt(endRes[2], 10) -
                    parseInt(beginRes[1], 10) * 60 -
                    parseInt(beginRes[2], 10);
            }
        }
        return 0;
    },

    wrap: function(content) {
        return content;
    },

    pickOneCDNHost: function(config, options) {
        return pickOneCDNHost(config, options);
    },

    // resizeImageUrl: function(imgUrl, width, height) {
    //     width = width || 0;
    //     height = height || 0;

    //     imgUrl = imgUrl || '';
    //     // 过滤图片url后面带'?'的情况
    //     imgUrl = imgUrl.split('?')[0];

    //     if (height > 0) {//如果height传值,则表示是直接传的宽高
    //         if (imgUrl.indexOf('/default') != -1) {
    //             return imgUrl.replace(/^(.*)(_w\d{2,3}_h\d{2,3}_c1_t0)?\.(jpg|png|jpeg|gif)$/i, '$1_w' + width + '_h' + height + '_c1_t0.$3');
    //         }
    //         return imgUrl.replace(/^(.*)(_w\d{2,3}_h\d{2,3}_c1_t0)?\.(jpg|png|jpeg|gif|bmp|gif|psd|pcx|ai|svg|tga|raw|tiff)$/i, '$1_w' + width + '_h' + height + '_c1_t0.$3');
    //     }

    //     if (width == 1) {
    //         return imgUrl.replace(/^(.*)(_w\d{2,3}_h\d{2,3}_c1_t0)?\.(jpg|png|jpeg|gif|bmp|gif|psd|pcx|ai|svg|tga|raw|tiff)$/i, '$1_w600_h160_c1_t0.$3');
    //     } else if (width == 2) {
    //         return imgUrl.replace(/^(.*)(_w\d{2,3}_h\d{2,3}_c1_t0)?\.(jpg|png|jpeg|gif|bmp|gif|psd|pcx|ai|svg|tga|raw|tiff)$/i, '$1_w320_h180_c1_t0.$3');
    //     } else if (width == 99) {
    //         //暂定目的地图片地址尺寸
    //         return imgUrl.replace(/^(.*)(_w\d{2,3}_h\d{2,3}_c1_t0)?\.(jpg|png|jpeg|gif|bmp|gif|psd|pcx|ai|svg|tga|raw|tiff)$/i, '$1_w214_h160_c1_t0.$3');
    //     } else {
    //         return imgUrl.replace(/^(.*)(_w\d{2,3}_h\d{2,3}_c1_t0)?\.(jpg|png|jpeg|gif|bmp|gif|psd|pcx|ai|svg|tga|raw|tiff)$/i, '$1_w180_h180_c1_t0.$3');
    //     }
    // }
}


// WEBPACK FOOTER //
// node_modules/@tuniu/light-helper/index.js